import { Injectable } from '@angular/core';
import { Enums, IEnums } from 'app/app.enums';

interface ILocalCacheService {
  retrieveCache<T>(storageKey: string): T | null;
  setCache<T>(storageKey: string, cacheData: T): boolean;
  purgeCache(storageKey: string): void;
  purgeAllCaches(): void;
}

@Injectable({ providedIn: 'root' })
export class CacheService implements ILocalCacheService {
  private enums: IEnums = Enums;
  private prefix = 'ms-';

  retrieveCache<T>(storageKey: string): T | null {
    const key = this.prefix + storageKey;
    const data = localStorage.getItem(key);
    if (data) {
      return <T>JSON.parse(data);
    }
    return null;
  }

  setCache<T>(storageKey: string, cacheData: T): boolean {
    const key = this.prefix + storageKey;
    localStorage.setItem(key, JSON.stringify(cacheData));
    return true;
  }

  purgeCache(storageKey: string): void {
    const key = this.prefix + storageKey;
    localStorage.removeItem(key);
  }

  purgeAllCaches(): void {
    localStorage.clear();
  }
}
